import { render, staticRenderFns } from "./ServiceList.vue?vue&type=template&id=8c22ba5a&"
import script from "./ServiceList.vue?vue&type=script&lang=ts&"
export * from "./ServiceList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports